import styled, { css } from 'styled-components';
import { ButtonStyles } from './Button';

interface Props {
  btnStyle: ButtonStyles;
  hasIcon: boolean;
}

const ButtonStyled = styled.button`
  ${({ btnStyle, hasIcon }: Props) => {
    return css`
      width: 100%;
      background-color: #00857e;
      border: 0.125em solid #00857e;
      color: #fff;
      border-radius: 0.188em;
      font-weight: bold;
      font-size: 0.875em;
      line-height: 1.5em;
      padding: 0.5em 0.75em;
      transition: ease-out 250ms background-color;
      &:hover {
        background-color: #006c67;
      }
      &:active {
        background-color: #00857e;
        border: 0.125em solid #006c67;
      }
      &:disabled,
      &:disabled:hover {
        background-color: #949494;
        border-color: #949494;
        color: #fff;
        cursor: not-allowed;
      }
      &:focus {
        outline: 0.125em solid transparent;
        box-shadow: inset 0 0 0 0.125em var(--a11y);
      }
      ${btnStyle === 'secondary' &&
      css`
        border: 0.125em solid #dbdbdb;
        background-color: #fff;
        color: #444444;
        &:hover {
          background-color: #f0f0f0;
        }
        &:active {
          background-color: #fafafa;
          border: 0.125em solid #949494;
        }
      `}
      ${btnStyle === 'tertiary' &&
      css`
        border: 0.125em solid transparent;
        background-color: transparent;
        color: #444444;
        &:hover {
          background-color: #f0f0f0;
          border: 0.125em solid #dbdbdb;
        }
        &:active {
          background-color: #fafafa;
          border: 0.125em solid #949494;
        }
      `}
      ${btnStyle === 'warning' &&
      css`
        border: 0.125em solid #ca2121;
        background-color: #ca2121;
        color: #fff;
        &:hover {
          background-color: #b71a1a;
        }
        &:active {
          background-color: #ca2121;
          border: 0.125em solid #b71a1a;
        }
      `}
      ${hasIcon &&
      css`
        display: flex;
        align-items: center;
        span {
          margin-left: 0.5em;
        }
      `}
    `;
  }};
`;

export default ButtonStyled;
